module.exports = __webpack_public_path__ + "img/not-found.180c1e82.svg";